// extracted by mini-css-extract-plugin
export default {"metamaskLogoContainer":"MetaMaskForm_metamaskLogoContainer__oUGT5","metamaskLogo":"MetaMaskForm_metamaskLogo__A3NmK","metaMaskButton":"MetaMaskForm_metaMaskButton__ywJ1h"};